import {
  defaultHistoryFields,
  isDeletedField
} from "@/components/Tables/defaultFields";
import StringFilterModel from "@/components/Tables/Filters/models/stringFilterModel";

let professionalGroupsFields = [
  {
    key: "name",
    label: "Профгруппа",
    filter: new StringFilterModel()
  }
];

const professionalGroupsHistoryFields = [
  ...professionalGroupsFields,
  ...defaultHistoryFields
];

professionalGroupsFields.push(isDeletedField);

export { professionalGroupsFields, professionalGroupsHistoryFields };
